import { GET_FORM_TEMPLATE_ERROR } from './';

export default error => ({ type: GET_FORM_TEMPLATE_ERROR, payload: error });
